import request from '@/utils/request'

// 查询
export function fetchList(data) {
  return request.post('/reMatManualPrinting/pageNoMerge', data, {
    trim: true
  })
}

// 创建
export function create(data) {
  return request.post('/tbBaseMaterialContractExec/create', data)
}

// 修改
export function updateById(data) {
  return request.post('/reMatManualPrinting/updateById', data)
}

// 删除
export function deleteById(id) {
  return request.get(`/reMatManualPrinting/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch(ids) {
  return request.get('/reMatManualPrinting/delete/batch', {
    params: {
      ids
    }
  })
}

// 打印
export function printApi(data) {
  return request.post('/tbBaseMaterialContractExec/print', data)
}

// 是否打印成功
export function isPrintSuccessApi(data) {
  return request.post('/tbBaseMaterialContractExec/printRollBack', data)
}

export function getParentDept() {
  return request.get('/dataView/getParentDept')
}

//导入数据
export function uploadTemApi(data) {
  return request.post('/reMatManualPrinting/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  })
}

// 查询导入结果分页数据
export function importResultPageApi (data) {
  return request.post('/manualPrinting/page', data)
}

// 获取打印机模板列表对照数据
export function getListFiledApi(data) {
  return request.post('/printer/template/getTemplateFieldListByTemplateKey', data)
}

// 合并物资
export function mergeApi(ids) {
  return request.get('/reMatManualPrinting/merge', {
    params: {
      ids
    }
  })
}

// 清空全部数据
export function clearAllApi() {
  return request.get('/reMatManualPrinting/clearAll')
}